import { memberPrefix } from "./utils";

export const linkingConfig = {
  screens: {
    DeferredComp: memberPrefix("deferred-comp"),
    AddEmployment: memberPrefix("account/employment/add"),
    EmploymentRemove: memberPrefix("account/employment/remove"),
    EmploymentEdit: memberPrefix("account/employment/edit/:id"),
    CurrentEmploymentReview: memberPrefix("account/employment/review"),
    ChangeEmploymentType: memberPrefix("account/employment/edit/type"),
    UpdateEmployment: memberPrefix("account/employment/edit/update"),
    Account: {
      screens: {
        AccountShow: memberPrefix("account"),
        AccountEdit: memberPrefix("account/edit"),
        AccountSettings: memberPrefix("account/settings"),
        InvoiceList: memberPrefix("account/invoices"),
      },
    },
    AccountEditContact: {
      screens: {
        AccountEditContactInformation: memberPrefix("account/edit/contact"),
      },
    },
    EmailChange: {
      screens: {
        Initiate: memberPrefix("email-change/initiate"),
        Confirm: memberPrefix("email-change/confirm"),
        Success: memberPrefix("email-change/success"),
      },
    },
    DuesProxyPayment: memberPrefix("dues-proxy-payment/:id"),
    AssumeUser: memberPrefix("assume-user"),
    Videos: memberPrefix("videos"),
    VideosDetails: memberPrefix("video/detail"),
    PdrHistory: memberPrefix("pdr/:slug"),
    PdrDetails: memberPrefix("pdr/details/:id"),
    ReportPDR: {
      screens: {
        PreviewScreen: memberPrefix("pdr/report-pdr/:slug/preview"),
        ActivityFormScreen: memberPrefix("pdr/report-pdr/:slug/activity-form"),
      },
    },
  },
};

export const historyRules = [];
